/**
 * @file   src\components\AppDefaulttheme.tsx
 * @brief  App Default theme component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState, Button, useEffect, useParams } from '../utils/thirdpartyComponents';
import AddIcon from '../assets/images/icons/addicon';
import Carwashlogo from '../assets/images/theme-logo.svg';
import SplashScreen from './SplashScreen';
import HomeScreen from './HomeScreen';
import SubscriptionsScreen from './SubscriptionsScreen';
import { PRIMARY_COLOR, SECONDARY_COLOR, BUTTON_PRIMARY_COLOR, BUTTON_TEXT_COLOR, TEXT_PRIMARY_COLOR } from '../utils/constants';
import { userType } from '../utils/enums';

const AppDefaulttheme = ({ showCustomThemeScreen, formData, setFormData, cuserType }: { showCustomThemeScreen: () => void, formData: any, setFormData: (data: any) => void; cuserType: string }) => {
    const displayCustomTheme = async () => {
        showCustomThemeScreen()
    }
    const param = useParams();
    const carWashId = param.id ? parseInt(param.id) : 0;
    const [themeData, setThemeData] = useState({
        PrimaryColor: PRIMARY_COLOR,
        SecondaryColor: SECONDARY_COLOR,
        ButtonPrimaryColor: BUTTON_PRIMARY_COLOR,
        ButtonTextColor: BUTTON_TEXT_COLOR,
        TextPrimaryColor: TEXT_PRIMARY_COLOR
    });
    const [companyLogo, setCompanyLogo] = useState(Carwashlogo);

    useEffect(() => {
        if (cuserType === userType['CARWASH-OWNER']) {
            setFormData({
                appTheme: {
                    primary: themeData.PrimaryColor,
                    secondary: themeData.SecondaryColor,
                    btn_primary: themeData.ButtonPrimaryColor,
                    btn_secondary: themeData.ButtonTextColor,
                    text_primary: themeData.TextPrimaryColor
                },
                logoUrl: "",
                IsCustom: 0
            });
        }
        else {
            setFormData({
                appTheme: {
                    primary: themeData.PrimaryColor,
                    secondary: themeData.SecondaryColor,
                    btn_primary: themeData.ButtonPrimaryColor,
                    btn_secondary: themeData.ButtonTextColor,
                    text_primary: themeData.TextPrimaryColor
                },
                logoUrl: "",
                IsCustom: 0,
                carWashId: carWashId
            });
        }
    }, []);

    useEffect(() => {
        document.documentElement.style.setProperty('--PrimaryColor', themeData.PrimaryColor);
        document.documentElement.style.setProperty('--SecondaryColor', themeData.SecondaryColor);
        document.documentElement.style.setProperty('--ButtonPrimaryColor', themeData.ButtonPrimaryColor);
        document.documentElement.style.setProperty('--ButtonTextColor', themeData.ButtonTextColor);
        document.documentElement.style.setProperty('--TextPrimaryColor', themeData.TextPrimaryColor);
    }, [themeData]);

    return (
        <div className="settings-container mx-auto">
            <div className="inner-block mx-auto">
                <div className="title-sec d-flex align-items-center justify-content-between">
                    <h5 className='f-bold'>Default Theme</h5>
                    <Button
                        title='Add New Custom Theme'
                        variant="primary"
                        className="primary-btn d-flex align-items-center"
                        onClick={displayCustomTheme}
                    >
                        Add New Custom Theme
                        <AddIcon />
                    </Button>
                </div>
                <div className="theme-element-wrap">
                    <p>Default Theme</p>
                    <div className="color-palette d-flex align-items-center justify-content-center">
                        <div className="color-box" style={{ background: PRIMARY_COLOR }}></div>
                        <div className="color-box" style={{ background: SECONDARY_COLOR }}></div>
                        <div className="color-box" style={{ background: BUTTON_PRIMARY_COLOR }}></div>
                        <div className="color-box" style={{ background: BUTTON_TEXT_COLOR }}></div>
                        <div className="color-box" style={{ background: TEXT_PRIMARY_COLOR }}></div>
                    </div>
                </div>
                <div className="title-sec">
                    <h5 className='f-bold'>Default Logo</h5>
                </div>
                <div className="theme-element-wrap text-center">
                    <img src={Carwashlogo} alt="Car Wash App" className='mx-auto' />
                </div>
            </div>
            <div className="app-preview">
                <p>App Preview</p>
                <div className="app-screens d-flex scroll-custom">
                    <SplashScreen />
                    <HomeScreen />
                    <SubscriptionsScreen />
                </div>
            </div>
        </div>
    );
};
export default AppDefaulttheme;
